// i18n/getIntl.js
import { createIntl, createIntlCache } from 'react-intl';

let intl; // cache interno

export function createIntlInstance(locale, messages) {
  try {
    const cache = createIntlCache();
    intl = createIntl({ locale, messages }, cache);
    return intl;
  } catch (error) {
    return null;
  }
}

export function getIntl() {
  if (!intl) {
    throw new Error('Intl not initialized. Call createIntlInstance first.');
  }
  return intl;
}

export function isIntlReady() {
  return intl !== null && intl !== undefined;
}

export async function waitForIntl(maxAttempts = 50, delay = 10) {
  for (let i = 0; i < maxAttempts; i++) {
    if (isIntlReady()) {
      return getIntl();
    }
    await new Promise(resolve => setTimeout(resolve, delay));
  }
  throw new Error('Intl instance not available after waiting');
}
